/**
 * Date-extensions locale Portuguese [pt]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('pt', {
    monthNames: ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'],
    monthShortNames: ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'],
    dayNames: ['Domingo','Segunda-Feira','Terça-Feira','Quarta-Feira','Quinta-Feira','Sexta-Feira','Sábado'],
    dayShortNames: ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb']
});
